/** Session key for superadmin GUI role preview (UI only). */
export const ROLE_PREVIEW_STORAGE_KEY = 'ic_role_preview';

export function clearRolePreviewStorage(): void {
  try {
    sessionStorage.removeItem(ROLE_PREVIEW_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
